import {useLocation} from "react-router-dom";
import {Button, Modal} from "antd";
import {PlaySquareOutlined} from "@ant-design/icons";
import "./style.css"
import {useState, useEffect} from "react";
import YouTubeVideo from "../YouTubeVideo";
import {useTranslations} from "../../lang";
import api from "../../api";

function HeaderHelpLink() {

    const [modalOpen, setModalOpen] = useState(false);
    const [video, setVideo] = useState(null);
    const {translate, language} = useTranslations();
    const location = useLocation();

    useEffect(() => {
        // Fetch video from database based on current pathname and language
        api.getHelpVideoForPage(location.pathname, language)
            .then((videoData) => {
                setVideo(videoData);
            })
            .catch(() => {
                setVideo(null);
            });
    }, [location.pathname, language]);

    function showVideo(){
        setModalOpen(true)
    }

    if(!video) {
        return null
    }

    return (
        <>
            <Modal open={modalOpen} width={"90%"} destroyOnClose={true} onCancel={() => setModalOpen(false)} footer={(
                <Button onClick={() => setModalOpen(false)}>{translate('Sluiten')}</Button>
            )}>
                {modalOpen && video && (
                    <YouTubeVideo videoId={video.youtube_video_id}/>
                )}
            </Modal>
            <div className={"header-help-link-wrap"}>
                <Button onClick={() => showVideo()}>
                    <PlaySquareOutlined/> {translate('Help')}
                </Button>
            </div>

        </>
    )
}

export default HeaderHelpLink